/**
 * Service for getting attendance-data
 */

import Backend from '../Backend'
import LastEditorEntry from "./LastEditorEntry";

/* @ngInject */
class AttendanceData {

  static fetchAttendancesForEmployee = function(employeeId) {
    return Backend.getData(`/api/actions/kursefuermitarbeiter/${employeeId}`)
      .then(atts => atts.map(att => {
        att._type = 'attendance'
        return att
      }))
  }

  static fetchPlannedAttendancesForEmployee = function(employeeId) {
    return Backend.getData(`/api/TAB_MITARBEITER/${employeeId}/TAB_KURSANMELDUNG`);
  }

  static fetchAllAttendancesForEmployee = function(employeeId) {
    return Backend.getData(`/api/comp/attendancesforemployee?empid=${employeeId}`)
  }

  static fetchAllAttendancesForCourse = function(courseId) {
    return Backend.getData(`/api/comp/attendancesforcourse?courseid=${courseId}`)
  }

  static saveNewAttendance = function(payload) {
    return Backend.postData(`/api/TAB_KURSANMELDUNG/`, payload)
  }

  static fetchSingleAttendance = function(attendanceId) {
    return Backend.getData(`/api/TAB_KURSANMELDUNG/${attendanceId}`)
  }

  static saveAttendanceComment = function(attendanceId, comment, type) {
    let table, commentField, lastEditField = ""
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    if (type === 'attendance') {
      table = 'TAB_KURSVERWALTUNG'
      commentField = 'KV_Bemerkungen'
      lastEditField = 'KV_Bearbeiter'
    } else {
      table = 'TAB_KURSANMELDUNG'
      commentField = 'KA_Bemerkungen'
      lastEditField = 'KA_Bearbeiter'
    }

    const payload = {
      [commentField]: comment,
      [lastEditField]: lastEditMessage
    }

    return Backend.putData(`/api/${table}/${attendanceId}`, payload)
      .then(res => {
        return lastEditMessage
      })
  }

  static updatePlannedAttendance = function(plannedAttendanceId, newState) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    const payload = {
      KA_Status: newState,
      KA_Bearbeiter: lastEditMessage
    }

    return Backend.putData(`/api/TAB_KURSANMELDUNG/${plannedAttendanceId}`, payload)
  }

  static updatePlannedTypeAttendance = function(plannedAttendanceId, newType) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    const payload = {
      KA_Typ: newType,
      KA_Bearbeiter: lastEditMessage
    }

    return Backend.putData(`/api/TAB_KURSANMELDUNG/${plannedAttendanceId}`, payload)
  }

  static migratePlannedAttendance = function(employeeId, dateId, plannedAttendanceId, state, type) {

    // TODO: Change fieldnames in Backend
    const payload = {
        Mitarbeiter_ID: employeeId,
        Kurstermin_ID: dateId,
        Anmeldung_ID: plannedAttendanceId,
        Status: state,
        Typ: type,
    }

    return Backend.postData('/api/actions/kursanmeldung', payload)
  }

  static changeAttendanceState = function(attendanceId, newState) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    const payload = {
      KV_Statustext: newState,
      KV_Bearbeiter: lastEditMessage
    }

    return Backend.putData(`/api/TAB_KURSVERWALTUNG/${attendanceId}`, payload)
  }

  static changeAttendanceType = function(attendanceId, newType) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    const payload = {
      KV_Typ: newType,
      KV_Bearbeiter: lastEditMessage
    }

    return Backend.putData(`/api/TAB_KURSVERWALTUNG/${attendanceId}`, payload)
  }

  static changeAttendanceDate = function(attendanceId, dateId) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    const payload = {
      KV_Kurs_ID: dateId,
      KV_Bearbeiter: lastEditMessage
    }

    return Backend.putData(`/api/TAB_KURSVERWALTUNG/${attendanceId}`, payload)
  }

  static deletePlannedAttendance =function(attendanceId) {
    return Backend.deleteData(`/api/TAB_KURSANMELDUNG/${attendanceId}`)
  }

}

export default AttendanceData;
